<template>
  <section class="page orderAppraise">
    <div class="list-wrap">
      <div class="goods-box" v-for="(item, index) in goodsList" :key="index">
        <div class="cover-box">
          <el-image
            class="cover-img"
            fit="contain"
            :src="
              item.cover ||
              require('@/assets/images/default-bundle-cover.png') ||
              ''
            "
          ></el-image>
        </div>
        <div class="main-box">
          <div class="cell-row">
            <el-tag class="tag" v-if="item | resourceTag">{{
              item | resourceTag
            }}</el-tag>
            <div class="title ou-expand ou-ellipsis">
              {{ item.resourceName }}
            </div>
          </div>
          <div
            v-show="!!item.authorRecommendation"
            class="recommend ou-text-ellipsis-2"
          >
            {{ item.authorRecommendation }}
          </div>
          <el-form
            ref="appRaiseForm"
            :model="appRaiseForm[index]"
            :rules="appRaiseRules"
            label-suffix=": "
          >
            <el-form-item class="rate-item" label="商品评分" prop="rate">
              <el-rate
                :colors="['#D81E06', '#D81E06', '#D81E06']"
                v-model="appRaiseForm[index].rate"
              ></el-rate>
            </el-form-item>
            <el-form-item prop="content">
              <el-input
                resize="none"
                type="textarea"
                :rows="7"
                :maxLength="201"
                placeholder="请输入商品评价"
                v-model="appRaiseForm[index].content"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="footer-wrap">
      <el-button class="submit-btn" @click="handleSubmit">提交评价</el-button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { apiGetUserOrderList } from "@/api/user/order";
import { apiAddEvaluate } from "@/api/user/evaluate";
export default {
  name: "orderAppraise",
  components: {},
  data() {
    return {
      detail: {},
      goodsList: [],
      appRaiseForm: [],
      appRaiseRules: {
        rate: [{ required: true, trigger: "blur", message: "请选择评分" }],
        content: [
          {
            max: 200,
            trigger: ["blur", "change"],
            message: "评价内容最多可输入200字",
          },
        ],
      },
    };
  },
  watch: {},
  filters: {
    resourceTag(item) {
      let text = "-";
      if (item.sourceType === "subject") {
        text = "专题";
      } else if (item.sourceType === "goods") {
        text = item.sourceFile || "";
      }
      return text;
    },
  },
  computed: {
    ...mapGetters(["userId"]),
  },
  activated() {
    let { orderNumber } = this.$route.query;
    this.getOrderDetail(orderNumber);
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path === "/user/orderDetail/index") {
        let { orderNumber } = vm.$route.query;
        vm.getOrderDetail(orderNumber);
      }
    });
  },
  methods: {
    getOrderDetail(orderNumber) {
      // TODO：此处暂时用hack的方式, 通过传入订单号筛选订单列表的方式获取详情
      apiGetUserOrderList({
        userId: this.userId,
        pageNum: 1,
        pageSize: 2,
        keyword: orderNumber,
      }).then((res) => {
        let list = res.rows || [];
        if (list.length >= 2) {
          this.$message.error("获取详情失败，请稍后重试");
          retrun;
        }
        this.detail = list[0] || {};
        let dataList = this.detail.ocOrderChildList || [],
          formInitList = [];
        dataList.forEach((item) => {
          formInitList.push({ rate: 5, content: "" });
        });
        this.goodsList = dataList;
        this.appRaiseForm = formInitList;
      });
    },
    handleSubmit() {
      let forms = this.$refs.appRaiseForm;
      let data = [],
        hasError = false,
        completeFlag = 0;
      forms.forEach((form, index) => {
        form
          .validate()
          .then((value) => {
            let item = this.goodsList[index],
              formValue = this.appRaiseForm[index];
            console.log("当前表单对象", item);
            let { relevanceId, orderId, sourceType } = item;
            let { rate: score, content } = formValue;
            let obj = {
              content,
              orderId,
              relevanceId,
              score,
              type: sourceType,
            };
            data.push(obj);
            completeFlag++;
          })
          .catch(() => (hasError = true));
      });
      let updateWoker = setInterval(() => {
        if (completeFlag === forms.length) {
          clearInterval(updateWoker);
          if (hasError) {
            return;
          }
          apiAddEvaluate(data).then((res) => {
            if (res.data === "已评价过这些商品") {
              this.$message.error("已评价过此订单商品");
              return;
            }
            this.$message.success("评价成功");
            // 跳转我的评价页
            setTimeout(() => {
              this.$router.push("/user/myEvaluate");
            }, 1000);
          });
        }
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
.list-wrap {
  padding: 0 20px;
  .goods-box {
    padding: 30px 0;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    .cover-box {
      padding: 0 20px;
      .cover-img {
        width: 300px;
        height: 300px;
        box-shadow: 0 0 3px 2px #f2f2f2;
      }
    }
    .main-box ::v-deep {
      flex: 1;
      padding: 0 20px;
      .cell-row {
        display: flex;
        align-items: center;
        .tag {
          height: 24px;
          line-height: 22px;
          padding: 0 11px;
          background-color: #f9fdff;
          border: 1px solid #0081ce;
          border-radius: 6px;
          margin-right: 10px;
        }
        .title {
          font-size: 16px;
          color: #333333;
          font-weight: 400;
        }
      }
      .recommend {
        line-height: normal;
        margin-top: 20px;
        font-size: 14px;
        color: #666666;
      }
      .el-form-item.rate-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        margin-top: 20px;
        .el-form-item__label {
          line-height: normal;
          color: #333333;
        }
      }
      .el-textarea__inner {
        background-color: #f2f2f2;
        border-color: #f2f2f2;
        border-radius: 6px;
      }
      ::-webkit-input-placeholder {
        color: #999999;
      }
    }
  }
}
.footer-wrap {
  padding: 40px;
  text-align: center;
  .submit-btn {
    width: 140px;
    height: 40px;
    background: #2e9adb;
    border-radius: 6px;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
